import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { watchForNewBuild, watchForStaleBuild } from './lib/staleBuild';
import { watchErrors } from './lib/bugReports';
import './styles.css';

watchForStaleBuild();
watchForNewBuild();
watchErrors();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
